// Anything that isn't a lowercase alphanumeric or hyphen — runs collapse to a
// single `-` when the firstName is interpolated into the PDF filename.
export const FILENAME_UNSAFE = /[^a-z0-9-]+/g;
